import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './archived-invitations.styles'
import ArchivedTable from './archived-table/archived-table.container'
import ArchivedSkeleton from './archived-skeleton/archived-skeleton'
import { Pagination } from 'pobble-components/dist/pagination'

class ArchivedInvitations extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const {
      classes,
      pending,
      noInvitations,
      pagination,
      onPageChange
    } = this.props
    return noInvitations ? (
      <p>You haven't archived any invitations yet.</p>
    ) : pending ? (
      <ArchivedSkeleton />
    ) : (
      <div>
        <ArchivedTable />
        <div className={classes.pagination}>
          <Pagination onPageChange={onPageChange} data={pagination} />
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(ArchivedInvitations)
